export default {
  // Navigation
  "nav.expenses": "Expenses",
  "nav.expense_categories_configuration": "Expense Categories",

  // Expense Categories
  "expense_categories.title": "Expense Categories",
  "expense_categories.code": "Code",
  "expense_categories.name": "Name",
  "expense_categories.unit_price": "Unit Price",
  "expense_categories.unit": "Unit",
  "expense_categories.state": "State",
  "expense_categories.select_tenant": "Please select a tenant first.",
  "expense_categories.delete_confirm": "Are you sure you want to delete this expense category?",
  "expense_categories.created": "Expense category created successfully",
  "expense_categories.updated": "Expense category updated successfully",
  "expense_categories.error.code_required": "Code is required",
  "expense_categories.error.name_required": "Name is required",

  // List
  "expenses.title": "Expenses",
  "expenses.number": "Number",
  "expenses.description": "Description",
  "expenses.date": "Date",
  "expenses.employee": "Employee",
  "expenses.manager": "Manager",
  "expenses.paid_by": "Paid By",
  "expenses.paid_by_employee": "Employee (to reimburse)",
  "expenses.paid_by_company": "Company",
  "expenses.total": "Total",
  "expenses.state": "State",
  "expenses.currency": "Currency",
  "expenses.notes": "Notes",
  "expenses.select_tenant": "Please select a tenant first.",
  "expenses.delete_confirm": "Are you sure you want to delete this expense?",

  // States
  "expenses.state.draft": "Draft",
  "expenses.state.deleted": "Deleted",
  "expenses.state.submitted": "Submitted",
  "expenses.state.approved": "Approved",
  "expenses.state.posted": "Posted",
  "expenses.state.paid": "Paid",
  "expenses.state.refused": "Refused",

  // Form
  "expenses.new": "New Expense",
  "expenses.created": "Expense created successfully",
  "expenses.updated": "Expense updated successfully",
  "expenses.section.basic": "Basic Information",
  "expenses.section.rows": "Expense Rows",

  // Form validation
  "expenses.error.description_required": "Description is required",
  "expenses.error.date_required": "Date is required",
  "expenses.error.employee_required": "Employee is required",
  "expenses.error.account_required": "Account is required",

  // Row columns
  "expenses.row.description": "Description",
  "expenses.row.account": "Account",
  "expenses.row.amount": "Amount",
  "expenses.row.vat": "VAT",
  "expenses.row.vat_amount": "VAT Amount",
  "expenses.row.total": "Total",
  "expenses.row.category": "Category",
  "expenses.row.quantity": "Quantity",
  "expenses.row.unit_price": "Unit Price",
  "expenses.row.paid_by": "Paid By",
  "expenses.add_row": "Add Row",

  // Workflow actions
  "expenses.action.submit": "Submit",
  "expenses.action.submitting": "Submitting...",
  "expenses.action.approve": "Approve",
  "expenses.action.approving": "Approving...",
  "expenses.action.refuse": "Refuse",
  "expenses.action.refusing": "Refusing...",
  "expenses.action.post": "Post",
  "expenses.action.posting": "Posting...",
  "expenses.action.reset": "Reset to Draft",
  "expenses.action.resetting": "Resetting...",

  // Workflow messages
  "expenses.submitted": "Expense submitted for approval",
  "expenses.approved": "Expense approved",
  "expenses.refused": "Expense refused",
  "expenses.posted": "Expense posted to accounting",
  "expenses.reset": "Expense reset to draft",

  // Attachments
  "attachments.title": "Attachments",
  "attachments.none": "No attachments",
  "attachments.upload": "Upload",
  "attachments.uploaded": "Attachment uploaded",
  "attachments.deleted": "Attachment deleted",
  "attachments.upload_error": "Failed to upload attachment",
  "attachments.delete_error": "Failed to delete attachment",
  "attachments.download_error": "Failed to download attachment",
};
